import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { isBrowser } from "react-device-detect";
import { Container, Card, Nav, Row, Col, Badge } from 'react-bootstrap';
import gql from "graphql-tag";
import * as compose from "lodash.flowright";
import { graphql } from "react-apollo";

// Import Tab Components
import StudentSnapshot from "../components/student-profile-components/StudentSnapshot";
import StudentAcademicPerformance from "../components/student-profile-components/StudentAcademicPerformance";
import StudentLearningAnalytics from "../components/student-profile-components/StudentLearningAnalytics";
import StudentAttendance from "../components/student-profile-components/StudentAttendance";
import StudentFees from "../components/student-profile-components/StudentFees";
import StudentProfileRecords from "../components/student-profile-components/StudentProfileRecords";

// Import Analysis Components
import ResultAnalysisSection from "../components/analysis/result_analysis/ResultAnalysisSection";
import StrengthSection from "../components/analysis/strength/StrengthSection";
import TimeAnalysisSection from "../components/analysis/time_analysis/TimeAnalysisSection";
import ComplexityAnalysisSection from "../components/analysis/complexity_analysis/ComplexityAnalysisSection";
import moment from "moment";

const FETCH_PAYMENT_MODES = gql`
  query($id: Int) {
    getPaymentModes(id: $id) {
     id
     payment_mode
    }
  }
`;


const GET_STUDENT_FEE_REPORT = gql`
    query getStudentFeeReport($student_id: Int, $academic_year_id: Int) {
        getStudentFeeReport(student_id: $student_id, academic_year_id: $academic_year_id) {
            fee_type_id
            fee_type_name
            total_fee
            discount
            fee_amount
            terms {
                term_no
                term_amount
                term_date
                is_paid
                paid_amount
                paid_date
                payment_mode_id
                payment_id
                comments
                is_due_entry
                due_from_term_no
            }
        }
    }
`;

const GET_ORGANISATION_PROFILE = gql`
    query($institution_id: Int!) {
        getOrganisationProfile(institution_id: $institution_id) {
            id
            organisation_name
            logo
            complete_address
        }
    }
`;

const GET_MONTHLY_ATTENDANCE_REPORT = gql`
  query getMonthlyAttendanceReport(
    $academic_year_id: Int!
    $institute_id: Int!
    $branch_id: Int!
    $class_id: Int!
    $section_id: String
    $month: String
  ) {
    getMonthlyAttendanceReport(
      academic_year_id: $academic_year_id
      institute_id: $institute_id
      branch_id: $branch_id
      class_id: $class_id
      section_id: $section_id
      month: $month
    ) {
      student_id
      percentage
    }
  }
`;

const GET_ACADEMIC_PERFORMANCE_REPORT = gql`
  query getStudentAcademicPerformanceReport($student_id: Int!) {
    getStudentAcademicPerformanceReport(student_id: $student_id) {
      exam_phase
      academic_year
      academic_year_id
      exam_standard
      student_id
      student_name
      gender
      roll_no
      admission_no
      subjects {
        subject
        subject_id
        color_code
        marks
        internal_max_marks
        class_id
        class_name
        exam_phase_internals
        grade
        grade_point
      }
    }
  }
`;

class StudentProfilePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataClear: 0,
            feeReport: [],
            loading: false,
            orgProfile: null,
            overallAttendance: "0.0",
            overallAcademicScore: "0",
            academicChangeText: "—",
            academicChangeClass: "text-secondary",
            exam_type: "0,1",
            class_id: "1,2",
            exam_typevalue: { value: 2, label: 'ALL' },
            class_idvalue: { value: 0, label: 'ALL' }
        };
    }

    selecthandleInputChange = (ename, evalue) => {
        console.log("selecthandleInputChange", ename, evalue);
        const name = ename;
        const value = evalue;
        if (name === "exam_type") {
            if (value === "0") {
                this.setState({
                    exam_typevalue: { value: value, label: 'Practise' },
                    exam_type: value
                });
            }
            else if (value === "1") {
                this.setState({
                    exam_typevalue: { value: value, label: 'Exam' },
                    exam_type: value
                });
            }
            else if (value === "2") {
                this.setState({
                    exam_typevalue: { value: value, label: 'ALL' },
                    exam_type: "0,1"
                });
            }
        }
        if (name === "class_id") {
            if (value === "0") {
                this.setState({
                    class_idvalue: { value: value, label: 'ALL' },
                    class_id: "1,2"
                });
            }
            else if (value === "1") {
                this.setState({
                    class_idvalue: { value: value, label: 'Class-XI' },
                    class_id: value
                });
            }
            else if (value === "2") {
                this.setState({
                    class_idvalue: { value: value, label: 'Class-XII' },
                    class_id: value
                });
            }
        }
    };

    tabwisedefaultActiveKeyFun = (key) => {
        const { history, location } = this.props;
        let tabKey = "overview";
        if (key === "four") {
            tabKey = "time-analysis";
        } else if (key === "five") {
            tabKey = "complexity-analysis";
        }
        history.push({
            pathname: `/student-profile-details/${tabKey}`,
            state: location.state
        });
    };

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            Cookies.set("toggle", "wrapper");
        }
        this.forceUpdate();
    };

    // Helper to render active tab content
    renderTabContent = (activeTab, student) => {
        const studentMobile = student?.contact_no || student?.student_mobile || "";
        switch (activeTab) {
            case "overview":
                return (
                    <React.Fragment>
                        <ResultAnalysisSection
                            mobile={studentMobile}
                            seperationType="student"
                            stateData={this.state}
                            selecthandleInputChange={this.selecthandleInputChange}
                            tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun}
                        />
                        <StrengthSection
                            mobile={studentMobile}
                            seperationType="student"
                            stateData={this.state}
                            selecthandleInputChange={this.selecthandleInputChange}
                        />
                    </React.Fragment>
                );
            case "time-analysis":
                return (
                    <TimeAnalysisSection
                        mobile={studentMobile}
                        seperationType="student"
                        stateData={this.state}
                        selecthandleInputChange={this.selecthandleInputChange}
                    />
                );
            case "complexity-analysis":
                return (
                    <ComplexityAnalysisSection
                        mobile={studentMobile}
                        seperationType="student"
                        stateData={this.state}
                        selecthandleInputChange={this.selecthandleInputChange}
                    />
                );
            case "academic":
                return <StudentAcademicPerformance student={student} />;
            case "analytics":
                return <StudentLearningAnalytics student={student} />;
            case "attendance":
                return <StudentAttendance student={student} />;
            case "fees":
                return <StudentFees feeReport={this.state.feeReport} loading={this.state.loading} student={student} getPaymentModes={this.props.getPaymentModes?.getPaymentModes || []} getOrganisationProfile={this.state.orgProfile} />;
            case "profile-records":
                return <StudentProfileRecords student={student} />;
            case "snapshot":
            default:
                return <StudentSnapshot student={student} feeReport={this.state.feeReport} feeLoading={this.state.loading} client={this.props.client} />;
        }
    };

    componentDidMount() {
        this.fetchReport();
        this.fetchOrgProfile();
    }

    fetchOrgProfile = async () => {
        try {
            const institutionId = Cookies.get("institutionid");
            if (!institutionId) return;
            const result = await this.props.client.query({
                query: GET_ORGANISATION_PROFILE,
                variables: { institution_id: parseInt(institutionId) },
                fetchPolicy: "network-only",
            });
            this.setState({ orgProfile: result.data?.getOrganisationProfile || null });
        } catch (error) {
            console.error("Error fetching organisation profile:", error);
        }
    };

    componentDidUpdate(prevProps) {
        const prevStudent = prevProps.location?.state?.student;
        const currentStudent = this.props.location?.state?.student;
        const prevStudentId = prevStudent ? prevStudent.student_id : null;
        const currentStudentId = currentStudent ? currentStudent.student_id : null;
        if (currentStudentId && prevStudentId !== currentStudentId) {
            this.fetchReport();
        }
    }

    fetchReport = async () => {
        const student = this.props.location?.state?.student;
        const studentId = student ? student.student_id : null;
        const academicYear = student?.academic_year_id ? student.academic_year_id : 2;
        if (!studentId) {
            this.setState({
                feeReport: [],
                overallAttendance: "0.0",
                overallAcademicScore: "0",
                academicChangeText: "—",
                academicChangeClass: "text-secondary",
                loading: false
            });
            return;
        }
        this.setState({ loading: true });
        try {
            const institutionId = parseInt(Cookies.get("institutionid"));
            const branchId = parseInt(student.branch);
            const classId = parseInt(student.class);
            const sectionId = student.section ? student.section.toString() : "";

            const promises = [
                this.props.client.query({
                    query: GET_STUDENT_FEE_REPORT,
                    variables: { student_id: parseInt(studentId), academic_year_id: parseInt(academicYear) },
                    fetchPolicy: "network-only",
                }),
                this.props.client.query({
                    query: GET_ACADEMIC_PERFORMANCE_REPORT,
                    variables: { student_id: parseInt(studentId) },
                    fetchPolicy: "network-only"
                })
            ];

            if (institutionId && branchId && classId && sectionId) {
                promises.push(
                    this.props.client.query({
                        query: GET_MONTHLY_ATTENDANCE_REPORT,
                        variables: {
                            academic_year_id: academicYear,
                            institute_id: institutionId,
                            branch_id: branchId,
                            class_id: classId,
                            section_id: sectionId,
                            month: moment().format("YYYY-MM")
                        },
                        fetchPolicy: "network-only",
                    })
                );
            }

            const results = await Promise.all(promises);

            const feeData = results[0]?.data?.getStudentFeeReport || [];
            const performanceData = results[1]?.data?.getStudentAcademicPerformanceReport || [];
            let attendancePct = "82.5";

            if (results[2]) {
                const list = results[2]?.data?.getMonthlyAttendanceReport || [];
                const studentData = list.find(s => parseInt(s.student_id) === parseInt(studentId));
                if (studentData) {
                    attendancePct = parseFloat(studentData.percentage).toFixed(1);
                }
            }

            // Calculate overall Academic Score Average
            let totalMarksSum = 0;
            let marksCount = 0;
            performanceData.forEach(phase => {
                phase.subjects.forEach(sub => {
                    totalMarksSum += parseFloat(sub.marks) || 0;
                    marksCount++;
                });
            });
            const academicAvg = marksCount > 0 ? Math.round(totalMarksSum / marksCount) : "0";

            // Calculate phase-wise averages
            let academicChangeText = "—";
            let academicChangeClass = "text-secondary";

            const phaseAverages = performanceData.map(phase => {
                let phaseSum = 0;
                let phaseCount = 0;
                (phase.subjects || []).forEach(sub => {
                    const marksVal = parseFloat(sub.marks);
                    if (!isNaN(marksVal)) {
                        phaseSum += marksVal;
                        phaseCount++;
                    }
                });
                return {
                    phase: phase.exam_phase,
                    avg: phaseCount > 0 ? (phaseSum / phaseCount) : null
                };
            }).filter(p => p.avg !== null);

            if (phaseAverages.length >= 2) {
                const latestPhase = phaseAverages[phaseAverages.length - 1];
                const previousPhase = phaseAverages[phaseAverages.length - 2];
                const latestAvg = latestPhase.avg;
                const previousAvg = previousPhase.avg;
                const diff = latestAvg - previousAvg;
                const formattedDiff = Math.abs(diff).toFixed(1);

                if (diff > 0) {
                    academicChangeText = `▲ ${formattedDiff}% vs last term`;
                    academicChangeClass = "text-success";
                } else if (diff < 0) {
                    academicChangeText = `▼ ${formattedDiff}% vs last term`;
                    academicChangeClass = "text-danger";
                } else {
                    academicChangeText = `● 0.0% vs last term`;
                    academicChangeClass = "text-secondary";
                }
            } else if (phaseAverages.length === 1) {
                academicChangeText = "● 1st term assessment";
                academicChangeClass = "text-info";
            }

            this.setState({
                feeReport: feeData,
                overallAttendance: attendancePct,
                overallAcademicScore: academicAvg,
                academicChangeText: academicChangeText,
                academicChangeClass: academicChangeClass,
                loading: false
            });
        } catch (error) {
            console.error("Error in fetchReport:", error);
            this.setState({
                feeReport: [],
                overallAttendance: "0.0",
                overallAcademicScore: "0",
                academicChangeText: "—",
                academicChangeClass: "text-secondary",
                loading: false
            });
        }
    };

    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");

        const { location, history, match } = this.props;
        // Parse active tab from URL parameters. Defaults to 'overview'.
        const activeTab = match.params.tab || "overview";
        const student = location && location.state && location.state.student ? location.state.student : null;
        const { feeReport } = this.state;
        console.log("student", student);

        const dobValue = student?.dob || student?.date_of_birth;
        let formattedDob = "—";
        if (dobValue) {
            const parsed = moment(dobValue);
            if (parsed.isValid()) {
                const age = moment().diff(parsed, 'years');
                formattedDob = `${parsed.format('DD MMM YYYY')} (${age} yrs)`;
            } else {
                formattedDob = dobValue;
            }
        }

        const pendingRows = feeReport.map(ft => {
            const paid = (ft.terms || []).reduce((s, t) => s + (parseInt(t.paid_amount) || 0), 0);
            const total = ft.fee_amount || ft.total_fee || 0;
            const pending = Math.max(0, total - paid);
            return { name: ft.fee_type_name, total, paid, pending };
        });
        const totalPendingFee = pendingRows.reduce((sum, row) => sum + row.pending, 0);

        return (
            <div className={Cookies.get("toggle")}>
                <style>{`
                    .fee-shimmer {
                        background: #f6f7f8;
                        background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
                        background-repeat: no-repeat;
                        background-size: 800px 104px;
                        display: inline-block;
                        position: relative;
                        animation-duration: 1.2s;
                        animation-fill-mode: forwards;
                        animation-iteration-count: infinite;
                        animation-name: placeholderShimmer;
                        animation-timing-function: linear;
                    }
                    @keyframes placeholderShimmer {
                        0% { background-position: -468px 0; }
                        100% { background-position: 468px 0; }
                    }
                `}</style>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <div
                        id="sidebar"
                        className={
                            isBrowser === true
                                ? "sidebar-menu d-none d-xl-block d-lg-block"
                                : "sidebar-menu d-block d-xl-none d-lg-none"
                        }
                    >
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        <Container fluid className="mt-4">

                            {/* Profile Info & Metrics Combined Card */}
                            <Card className="border-0 mb-4 mt-4" style={{
                                borderRadius: '20px',
                                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.04)',
                                border: '1px solid rgba(226, 232, 240, 0.8)'
                            }}>
                                <Card.Body className="p-4">
                                    <Row className="align-items-center">
                                        {/* Avatar Icon */}
                                        <Col xs="auto" className="mb-3 mb-md-0">
                                            {(() => {
                                                const photoSrc = student?.profile_image_base;
                                                return photoSrc ? (
                                                    <img
                                                        src={photoSrc}
                                                        alt={student?.student_name || "Profile"}
                                                        style={{
                                                            width: '95px',
                                                            height: '95px',
                                                            borderRadius: '20px',
                                                            objectFit: 'cover',
                                                            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
                                                            border: '3px solid #ffffff'
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="d-flex align-items-center justify-content-center text-white font-weight-bold"
                                                        style={{
                                                            width: '95px',
                                                            height: '95px',
                                                            borderRadius: '20px',
                                                            background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
                                                            fontSize: '2.5rem',
                                                            boxShadow: '0 8px 24px rgba(79, 70, 229, 0.2)',
                                                            border: '3px solid #ffffff'
                                                        }}>
                                                        {student && student.student_name ? student.student_name.charAt(0).toUpperCase() : "A"}
                                                    </div>
                                                );
                                            })()}
                                        </Col>

                                        {/* Student Details */}
                                        <Col className="flex-grow-1">
                                            <Row>
                                                <Col sm={9} xs={8} className="d-flex align-items-center">
                                                    <h3 className="mb-0 font-weight-bold text-dark mr-3" style={{ fontFamily: "'Outfit', sans-serif", fontSize: '28px', letterSpacing: '-0.5px' }}>
                                                        {student ? student.student_name : "Aarav Sharma"}
                                                    </h3>
                                                </Col>

                                                {/* <Col sm={3} xs={4} className="text-right d-flex justify-content-end align-items-center">
                                                    <button
                                                        onClick={() => history.push("/settings/non-academic-students")}
                                                        style={{
                                                            background: "#ffffff",
                                                            border: "1px solid #e2e8f0",
                                                            color: "#64748b",
                                                            borderRadius: "10px",
                                                            padding: "8px 18px",
                                                            fontSize: "14px",
                                                            fontWeight: "600",
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            transition: "all 0.2s ease",
                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.currentTarget.style.color = '#4f46e5';
                                                            e.currentTarget.style.borderColor = '#6366f1';
                                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(99, 102, 241, 0.1)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.currentTarget.style.color = '#64748b';
                                                            e.currentTarget.style.borderColor = '#e2e8f0';
                                                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.02)';
                                                        }}
                                                    >
                                                        <i className="fas fa-arrow-left"></i> Back
                                                    </button>
                                                </Col> */}

                                                <Col sm={12} className="mt-2">
                                                    <div className="d-flex flex-wrap align-items-center" style={{ gap: '8px' }}>
                                                        <Badge className="py-1.5 px-3" style={{ backgroundColor: '#f0fdf4', color: '#16a34a', borderRadius: '30px', fontWeight: '600', fontSize: '12px', border: 'none' }}>
                                                            {student && student.is_academic_exist ? "Active" : "Enrolled - Active"}
                                                        </Badge>
                                                        <Badge className="py-1.5 px-3" style={{ backgroundColor: '#eff6ff', color: '#1d4ed8', borderRadius: '30px', fontWeight: '600', fontSize: '12px', border: 'none' }}>
                                                            {student ? `Grade ${student.class_name || ""} - Section ${student.section_name || ""}` : "Grade 6 - Section A"}
                                                        </Badge>
                                                        <Badge className="py-1.5 px-3" style={{ backgroundColor: '#f1f5f9', color: '#475569', borderRadius: '30px', fontWeight: '600', fontSize: '12px', border: 'none' }}>
                                                            Roll No. {student ? student.roll_no : "42"}
                                                        </Badge>
                                                        <Badge className="py-1.5 px-3" style={{ backgroundColor: '#f1f5f9', color: '#475569', borderRadius: '30px', fontWeight: '600', fontSize: '12px', border: 'none' }}>
                                                            Adm: {student?.admission_no || student?.admissionNumber || "—"}
                                                        </Badge>
                                                    </div>
                                                </Col>

                                                <Col sm={12} className="mt-2">
                                                    <div className="d-flex flex-wrap align-items-center mt-3 pt-3" style={{ gap: '24px', borderTop: '1px dashed #e2e8f0' }}>
                                                        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                                            <div className="d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#f0fdf4', color: '#16a34a' }}>
                                                                <i className="fas fa-birthday-cake" style={{ fontSize: '13px' }}></i>
                                                            </div>
                                                            <div>
                                                                <span className="d-block text-muted" style={{ fontSize: '11px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Date of Birth</span>
                                                                <strong style={{ color: '#334155', fontSize: '13px' }}>{formattedDob}</strong>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                                            <div className="d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#eff6ff', color: '#1d4ed8' }}>
                                                                <i className="fas fa-user-tie" style={{ fontSize: '13px' }}></i>
                                                            </div>
                                                            <div>
                                                                <span className="d-block text-muted" style={{ fontSize: '11px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Father's Details</span>
                                                                <strong style={{ color: '#334155', fontSize: '13px' }}>{student?.father_name && student.father_name !== "-" ? `${student.father_name}${student.father_phone || student.father_mobile ? ` - ${student.father_phone || student.father_mobile}` : ''}` : "—"}</strong>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                                            <div className="d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#fdf2f8', color: '#be185d' }}>
                                                                <i className="fas fa-female" style={{ fontSize: '13px' }}></i>
                                                            </div>
                                                            <div>
                                                                <span className="d-block text-muted" style={{ fontSize: '11px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Mother's Details</span>
                                                                <strong style={{ color: '#334155', fontSize: '13px' }}>{student?.mother_name && student.mother_name !== "-" ? `${student.mother_name}${student.mother_phone || student.mother_mobile ? ` - ${student.mother_phone || student.mother_mobile}` : ''}` : "—"}</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    {/* Divider */}
                                    {/* <hr style={{ borderColor: '#a8a8a8ff', margin: '24px 0 16px 0' }} /> */}

                                    {/* Stats Grid */}
                                    {/* <Row className="text-center text-md-left">
                                        <Col md={4} sm={12} xs={12} className="mb-3 mb-md-0 border-right" style={{ borderColor: '#a8a8a8ff' }}>
                                            <span className="text-muted small font-weight-bold text-uppercase d-block mb-1">
                                                <i className="fas fa-graduation-cap mr-1"></i> Academic Score
                                            </span>
                                            {this.state.loading ? (
                                                <div className="d-flex flex-column gap-2 mt-2">
                                                    <Shimmer width="60px" height="24px" />
                                                    <Shimmer width="100px" height="12px" style={{ marginTop: '4px' }} />
                                                </div>
                                            ) : (
                                                <>
                                                    <h3 className="font-weight-bold mb-0 text-success" style={{ fontSize: '1.6rem' }}>{this.state.overallAcademicScore}%</h3>
                                                    <span className={`${this.state.academicChangeClass || 'text-secondary'} small font-weight-bold`}>
                                                        {this.state.academicChangeText || '—'}
                                                    </span>
                                                </>
                                            )}
                                        </Col>
                                   <Col md={2} sm={4} xs={6} className="mb-3 mb-md-0 border-right" style={{ borderColor: '#a8a8a8ff' }}>
                                            <span className="text-muted small font-weight-bold text-uppercase d-block mb-1">
                                                <i className="fas fa-trophy mr-1"></i> Class Rank
                                            </span>
                                            {this.state.loading ? (
                                                <div className="d-flex flex-column gap-2 mt-2">
                                                    <Shimmer width="80px" height="24px" />
                                                    <Shimmer width="110px" height="12px" style={{ marginTop: '4px' }} />
                                                </div>
                                            ) : (
                                                <>
                                                    <h3 className="font-weight-bold mb-0 text-dark" style={{ fontSize: '1.6rem' }}>12 <span className="text-muted" style={{ fontSize: '1rem' }}>/ 42</span></h3>
                                                    <span className="text-secondary small">Top 29% · Section A</span>
                                                </>
                                            )}
                                        </Col>  
                                        <Col md={4} sm={12} xs={12} className="mb-3 mb-md-0 border-right" style={{ borderColor: '#a8a8a8ff' }}>
                                            <span className="text-muted small font-weight-bold text-uppercase d-block mb-1">
                                                <i className="fas fa-calendar-check mr-1"></i> Attendance
                                            </span>
                                            {this.state.loading ? (
                                                <div className="d-flex flex-column gap-2 mt-2">
                                                    <Shimmer width="70px" height="24px" />
                                                    <Shimmer width="100px" height="12px" style={{ marginTop: '4px' }} />
                                                </div>
                                            ) : (
                                                <>
                                                    <h3 className="font-weight-bold mb-0" style={{ color: '#d97706', fontSize: '1.6rem' }}>{this.state.overallAttendance}%</h3>
                                                    <span className="text-warning small font-weight-bold">{parseFloat(this.state.overallAttendance) < 85 ? '● Below 85% target' : '● Above 85% target'}</span>
                                                </>
                                            )}
                                        </Col>
                                        <Col md={4} sm={12} xs={12} className="mb-3 mb-md-0 border-right" style={{ borderColor: '#a8a8a8ff' }}>
                                            <span className="text-muted small font-weight-bold text-uppercase d-block mb-1">
                                                <i className="fas fa-rupee-sign mr-1"></i> Fees
                                            </span>
                                            {this.state.loading ? (
                                                <div className="d-flex flex-column gap-2 mt-2">
                                                    <Shimmer width="75px" height="24px" />
                                                    <Shimmer width="120px" height="12px" style={{ marginTop: '4px' }} />
                                                </div>
                                            ) : (
                                                <>
                                                    <h3 className="font-weight-bold mb-0 text-danger" style={{ fontSize: '1.6rem' }}>₹{totalPendingFee.toLocaleString()}</h3>
                                                    <span className="text-secondary small">{totalPendingFee > 0 ? "Pending dues" : "Fully paid"}</span>
                                                </>
                                            )}
                                        </Col>
                                        {/* <Col md={3} sm={6} xs={12}>
                                            <span className="text-muted small font-weight-bold text-uppercase d-block mb-1">
                                                <i className="fas fa-shield-alt mr-1"></i> Discipline
                                            </span>
                                            {this.state.loading ? (
                                                <div className="d-flex flex-column gap-2 mt-2">
                                                    <Shimmer width="50px" height="24px" />
                                                    <Shimmer width="110px" height="12px" style={{ marginTop: '4px' }} />
                                                </div>
                                            ) : (
                                                <>
                                                    <h3 className="font-weight-bold mb-0 text-success" style={{ fontSize: '1.6rem' }}>A</h3>
                                                    <span className="text-secondary small">No incidents this term</span>
                                                </>
                                            )}
                                        </Col> 
                                </Row> */}
                                </Card.Body>
                            </Card>

                            {/* Tab Selection Area */}
                            <div className="p-2 mb-4 d-flex align-items-center flex-row" style={{ backgroundColor: '#f4f3ee', borderRadius: '12px', overflowX: 'auto', gap: '8px' }}>
                                {[
                                    // { key: 'snapshot', label: 'Snapshot', icon: 'fa-home' },
                                    { key: 'overview', label: 'Overview', icon: 'fa-eye' },
                                    { key: 'time-analysis', label: 'Time Analysis', icon: 'fa-clock' },
                                    { key: 'complexity-analysis', label: 'Complexity Analysis', icon: 'fa-cogs' },
                                    // { key: 'academic', label: 'Academic Performance', icon: 'fa-chart-bar' },
                                    // { key: 'analytics', label: 'Learning Analytics', icon: 'fa-brain' },
                                    { key: 'attendance', label: 'Attendance', icon: 'fa-calendar-alt' },
                                    { key: 'fees', label: 'Fees', icon: 'fa-credit-card' },
                                    { key: 'profile-records', label: 'Profile & Records', icon: 'fa-id-card' }
                                ].map((t) => (
                                    <div
                                        key={t.key}
                                        onClick={() => history.push({ pathname: `/student-profile-details/${t.key}`, state: location.state })}
                                        style={{
                                            fontWeight: 600,
                                            borderRadius: '8px',
                                            color: activeTab === t.key ? '#1e293b' : '#64748b',
                                            backgroundColor: activeTab === t.key ? '#ffffff' : 'transparent',
                                            boxShadow: activeTab === t.key ? '0 2px 6px rgba(0,0,0,0.08)' : 'none',
                                            padding: '10px 18px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            fontSize: '14px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            whiteSpace: 'nowrap',
                                            userSelect: 'none'
                                        }}
                                    >
                                        <i className={`fas ${t.icon}`} style={{ fontSize: '14px' }}></i>
                                        {t.label}
                                    </div>
                                ))}
                            </div>

                            {/* Tab Content Display */}
                            <div className="bg-white p-4 shadow-sm mb-4" style={{ borderRadius: '16px', minHeight: '350px', border: '1px solid #f1f2f5' }}>
                                {this.renderTabContent(activeTab, student)}
                            </div>

                        </Container >
                    </div >
                    <Footer />
                </div >
            </div >
        );
    }
}
export default withRouter(withApollo(compose(
    graphql(FETCH_PAYMENT_MODES, {
        options: (props) => ({
            variables: {
                id: parseInt(0),
            },
            fetchPolicy: "cache-and-network",
        }),
        name: "getPaymentModes",
    }))(StudentProfilePage))
);